export default function langaugeFactory(languageCode){
    const INDONESIA = 1
    const ENGLISH = 2
    if(languageCode === INDONESIA){
        return languageIndonesia
    }
    if(languageCode === ENGLISH){
        return languageEnglish
    }
}

const languageIndonesia = {
    languageSelect : "Pilihan Bahasa",
    title: "Bukti Pengiriman ",
    driverName : "Pengemudi: ",
    fleet: "Armada: ",
    uploadButton: "Unggah",
    uploadFormTitle: "Unggah untuk ",
    uploadFormImage : "Gambar",
    uploadFormImageCaption : "Keterangan Gambar",
    pleaseWait : "Harap Tunggu...",
    enlarge: "Klik gambar untuk melihat ukuran aslinya",
    noImage: "Belum terdapat gambar terunggah!",
    required: "dibutuhkan",
    close: "Tutup",
    noDeliveryFound: "Delivery Order ID Tidak Ditemukan!",
    woCustomer : "Pelanggan Tujuan",
    woCustomerPhone : "Telepon Pelanggan",
    woAddress : "Alamat Destinasi",
    woTarget : "Estimasi Waktu Sampai",
    skip : "Selanjutnya",
    uploadCheck : "Pengecekan unggahan sedang berlangsung",
    done: "Sudah",
    uploadLimitReach:"Anda sudah mencapai batas percobaan unggah (2x unggah)!",
    help:"Untuk bantuan, Whatsapp CS Automa pada nomor 08112995355"
}

const languageEnglish = {
    languageSelect : "Language Select",
    title: "Proof of Delivery ",
    driverName : "Driver: ",
    fleet: "Fleet: ",
    uploadButton: "Upload",
    uploadFormTitle: "Upload for ",
    uploadFormImage : "Image",
    uploadFormImageCaption : "Image Caption",
    pleaseWait : "Please Wait...",
    enlarge: "Click the image to be able see the true size",
    noImage: "No uploaded image found!",
    required: "required",
    close: "Close",
    noDeliveryFound: "Delivery Order ID Not Found!",
    woCustomer : "Customer",
    woCustomerPhone : "Customer Phone",
    woAddress : "Destination Address",
    woTarget : "Estimation Arrival",
    skip : "Next",
    uploadCheck: "Please wait upload check in progress..",
    done: "Done",
    uploadLimitReach:"You have reach the limit of upload attempts(2x uploads)!",
    help:"Whatsapp Automa CS on 08112995355 for help"
}



// WEBPACK FOOTER //
// ./src/views/Transporter/WOPhotoUpload/language.js